// SPDX-License-Identifier: GPL-3.0-or-later
// Copyright (C) 2026 Radiooooo

// Wiring only, in four steps (src/boot/): the foundation, the landing and the
// session on screen, and the rest of the core with the frame and its views
// once there is a session to show it to (application.ts imports them, so they
// are a chunk of their own).

import { createFoundation } from "./boot/foundation";
import { startApplication } from "./boot/application";
import { interfaceStylesheet, stylesheetReady } from "./boot/stylesheet";
import { directionOf } from "./core/locale";

const root = document.getElementById("app");
if (!root) {
    throw new Error("Missing #app");
}

const core = createFoundation();
// the interface speaks the chosen language from its first frame; a language
// the CDN cannot give stays English
if (core.locale !== "en") {
    try {
        await core.i18n.load(core.locale);
    } catch (error) {
        console.warn(`i18n: ${core.locale} unavailable, staying in English`, error);
    }
}
const reflectLanguage = () => {
    document.documentElement.lang = core.i18n.locale();
    document.documentElement.dir = directionOf(core.i18n.locale());
};
reflectLanguage();
const stopLanguage = core.i18n.onChange(reflectLanguage);
// the one await before anything is on screen: the landing, like the frame after it, is never unstyled
await stylesheetReady(interfaceStylesheet());
const application = startApplication(core, root);
application.onDestroy(stopLanguage);

// A development build lets the console reach the client: force a state, open a
// view, read a store. The map has had `window.__rdMap` for the same reason.
// Never in a production bundle: the define is empty there and this is dropped.
if (process.env.RD_DEV) (window as unknown as { __rd?: unknown }).__rd = { foundation: core, core: application.core, frame: application.frame, destroy: application.destroy };
